// extracted by mini-css-extract-plugin
export default {"trash":"_3kcbq___ModelList-module__trash","row":"rleys___ModelList-module__row"};